import { render, staticRenderFns } from "./HDTopFiveFaultsForMonthToDate.vue?vue&type=template&id=8efbb044&"
import script from "./HDTopFiveFaultsForMonthToDate.vue?vue&type=script&lang=ts&"
export * from "./HDTopFiveFaultsForMonthToDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports